<template>
  <div
    class="form-check"
    :class="{
      'form-switch': isSwitch,
      'custom-checkbox': !isSwitch,
      [computedClass]: computedClass
    }"
  >
    <input
      v-bind="computedAttrs"
      :id="_id"
      ref="input"
      v-model="model"
      class="form-check-input"
      :role="isSwitch ? 'switch' : 'checkbox'"
      type="checkbox"
      :value="value"
      :disabled="disabled"
    >
    <label
      class="custom-control-label"
      :for="_id"
    >
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: 'BFormCheckbox',
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [Boolean, Array],
      default: undefined
    },
    value: {
      type: [Boolean, String, Number]
    },
    switch: Boolean,
    checked: Boolean,
    disabled: Boolean,
    indeterminate: Boolean
  },
  emits: ['update:modelValue', 'update:indeterminate', 'change'],
  computed: {
    model: {
      get() {
        return this.modelValue !== undefined ? this.modelValue : this.checked
      },
      set(value) {
        this.$emit('update:modelValue', value)
        this.$emit('change', value)
      }
    },
    isSwitch() {
      return this.switch
    },
    computedClass() {
      return this.$attrs.class
    },
    computedAttrs() {
      const attrs = { ...this.$attrs }
      attrs.class = null
      return attrs
    }
  },
  watch: {
    indeterminate(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setIndeterminate(newValue)
      }
    }
  },
  created() {
    this._id = `_BV_checkbox_${this.$uuid}`
  },
  mounted() {
    this.setIndeterminate(this.indeterminate)
  },
  methods: {
    setIndeterminate(state) {
      const $input = this.$refs.input
      if ($input) {
        $input.indeterminate = state
        this.$emit('update:indeterminate', state)
      }
    }
  }
}
</script>
